import { getPlayitApiV2Base } from "../helpers/playitApiConfig";

const environment = {
  production: true,
  apiUrl: getPlayitApiV2Base(),
  apiKey: ""
};
export default environment;
